export enum EMenuFilters {
  UnhandledIncomignId = "1B8AE8D3-3209-497D-9526-27608FFFA84D",
  HandledIncomignId = "308F8126-F3B8-4D6F-BD67-0111457DB69E",
  SpamIncomingId = "6cac2097-1014-46a4-8d99-46068cf0a729",

  AllOutgoingId = "2E7191EA-F56D-4DA9-924F-9334A1C153F3",

  RemovedIncomingId = "36ba76fc-cf24-4188-8482-765d41dcc964",
  RemovedOutgoingId = "36ba76fc-cf24-4188-8482-765d41dcc965",
  RemovedTasksId = "28349a7c-37db-4731-85f9-697dafe1624f",

  AllTasksId = "728739AD-37D7-4E59-8AA1-2B6DE0EEF88A",
}
